import { faCopy } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";

interface CopyButtonProps {
  textToCopy: string;
}

const CopyButton: React.FC<CopyButtonProps> = ({ textToCopy }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(textToCopy);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  };

  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      <button onClick={handleCopy} className="btn-transparent">
        <FontAwesomeIcon
          icon={faCopy}
          className="text-secondary cursor-pointer"
          title="Copy to clipboard"
        />
      </button>

      {copied && <span className="small-toast">Copied</span>}
    </div>
  );
};

export default CopyButton;
